import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  useQueryParams,
  StringParam,
  withDefault,
  NumberParam,
} from 'use-query-params';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';
import { useLoading } from '../../../commons/Loading';
import CondosPresentational from './CondosPresentational';
const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const AdminCondos = ({ profile }) => {
  const [condos, setCondos] = useState([]);
  const [total, setTotal] = useState(0);
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [adminCollabs, setAdminCollabs] = useState([]);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    admin: withDefault(StringParam, ''),
    name: withDefault(StringParam, ''),
    vatCode: withDefault(StringParam, ''),
    address: withDefault(StringParam, ''),
    adminCollab: withDefault(StringParam, ''),
    condosActive: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    admin,
    name,
    vatCode,
    address,
    adminCollab,
    condosActive,
  } = query;

  useEffect(() => {
    if (!(Object.keys(profile).length === 0)) {
      fetchCondos();
      fetchAdminCollabs();
    }
  }, [limit, offset, admin, name, vatCode, address, adminCollab, condosActive]);

  const fetchCondos = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/condos/${profile._id}`,
      {
        headers: { Authorization: newToken },
        params: {
          limit,
          offset,
          admin,
          name,
          vatCode,
          address,
          adminCollab,
          condosActive,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [], headers = {} } = response;
    setCondos(data.condos);
    setTotal(+headers['x-total-count']);
  };

  function onFilter(queryDiff) {
    if (
      (queryDiff.admin && queryDiff.admin !== admin) || // first search
      (admin && queryDiff.admin === '') || // search deleted
      (queryDiff.name && queryDiff.name !== name) || // first search
      (name && queryDiff.name === '') || // search deleted
      (queryDiff.vatCode && queryDiff.vatCode !== vatCode) || // first search
      (vatCode && queryDiff.vatCode === '') || // search deleted
      (queryDiff.address && queryDiff.address !== address) || // first search
      (address && queryDiff.address === '') || // search deleted
      (queryDiff.condosActive && queryDiff.condosActive !== condosActive) || // first search
      (condosActive && queryDiff.condosActive === 'true') || // search deleted
      (queryDiff.adminCollab && queryDiff.adminCollab !== adminCollab) || // first search
      (adminCollab && queryDiff.adminCollab === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchAdminCollabs = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/profiles/admin-collabs`,
      {
        headers: { Authorization: newToken },
        params: {
          adminId: profile
            ? profile.type === 'ADMIN_COLLAB'
              ? profile.adminId
              : profile._id
            : '',
        },
      }
    );

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data = [] } = response;
    setAdminCollabs(data);
  };

  return (
    <CondosPresentational
      data={condos}
      profile={profile}
      query={query}
      total={total}
      onFilter={onFilter}
      adminCollabs={adminCollabs}
    />
  );
};

export default AdminCondos;
